import request from "@/util/request";

// 获取交易项目详情
export function getProjectDetail(data) {
  return request({
    url: "/api/outProjectDetail",
    data: data,
    method: "post"
    // headers: {
    //     'Authorization': 'Bearer ' + localStorage.getItem('token')
    // }
  });
}

// 获取交易项目溢价
export function getCurrentPrice(data) {
  return request({
    url: "/api/getCurrentPrice",
    data: data,
    method: "post",
    // headers: {
    //   Authorization: "Bearer " + localStorage.getItem("token")
    // }
  });
}

// 竞拍出价
export function auctionBid(data) {
  return request({
    url: "/auction/auctionBid",
    data: data,
    method: "post",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token")
    }
  });
}

// 交易项目报名
export function auctionApply(data) {
  return request({
    url: "/auction/auctionApply",
    data: data,
    method: "post",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token")
    }
  });
}

// 交易项目报名须知
export function enroll(data) {
  return request({
    url: "/api/news/enroll",
    data: data,
    method: "post"
  });
}

// 获取用户信息
export function getUserInfoByUserId() {
  return request({
    url: "/system/userInfo/getUserInfoByUserId",
    method: "post",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token")
    }
  });
}

// 获取交易项目是否报名
export function isApply(data) {
  return request({
    url: "/auction/isApply ",
    data: data,
    method: "post",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token")
    }
  });
}

// 报过名的项目
export function applyProjectList() {
  return request({
    url: "/userInfo/applyProjectList",
    method: "post",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token")
    }
  });
}

// 竞价过的项目
export function bidProjectList() {
  return request({
    url: "/userInfo/bidProjectList",
    method: "post",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token")
    }
  });
}

// 中标的项目
export function succeedProjectList() {
  return request({
    url: "/userInfo/succeedProjectList",
    method: "post",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token")
    }
  });
}

// 根据组织机构获取银行账号基本信息详细信息
export function getInfoByDeptId(deptId) {
  return request({
    method: 'get',
    url: '/api/getBankInfoByDeptId?deptId=' + deptId,
  })
}

// 获取银行账号基本信息详细信息
export function getBankCardInfo(data) {
  return request({
    method: 'post',
    data: data,
    url: '/transfer/bankCardInfo/getInfo',
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token")
    }
  })
}

// 产权转出项目围观接口
export function watchProject(data) {
  return request({
    method: 'post',
    params: data,
    url: '/api/watchProject',
  })
}

// 获取字典
export function getTypeList(type) {
  return request({
    url: '/api/typeList',
    method: 'post',
    data: {
      dictType: type
    }
  })
}